module.exports = __webpack_public_path__ + "static/media/value_prop_img_4.995446d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-WEB/value_prop_img_4.jpg
// module id = 1434
// module chunks = 0